import {
   AuthenticationError,
   AuthorizationError,
   ServerError,
   ValidationError,
   NotFoundError,
   UnprocessableEntityError,
   MaintenanceError,
} from '@/core/Types/error';


export const severErrors = {
  400: ValidationError,
  401: AuthenticationError,
  403: AuthorizationError,
  404: NotFoundError,
  422: UnprocessableEntityError,
  500: ServerError,
  503: MaintenanceError,
};

export const languages = {
  es: 'Español',
  en: 'English',
  ch: '中國人',
};
